import { routerReducer } from "react-router-redux";
import { combineReducers } from "2g-utils-redux";
import modulesReducers from "rail-2g-universe/lib/js/reducer";
import rezervaceVytvoreniReducer from "b2b/components/rezervace-vytvoreni/reducer";
import smlouvaVytvoreniReducer from "b2b/components/smlouva-vytvoreni/reducer";

const rootReducer = combineReducers(
  [...modulesReducers, rezervaceVytvoreniReducer, smlouvaVytvoreniReducer],
  {
    routing: routerReducer
  }
);

export default rootReducer;
